import React from 'react';
import _ from 'lodash';

import LinkText from 'components/LinkText';
import Money from 'components/Money';
import {formatDate} from 'utils/datetime';
import PaymentStatusTag from 'components/PaymentStatusTag';

import './styles.css';

const LessCashRefunds = ({
  payments,
  invoices,
  openRefundDetailModal,
  openInvoiceDetailModal
}) => {
  const orderedPayments = _.orderBy(payments, 'paymentDate', 'asc');
  return (
    <div>
      {orderedPayments.map(payment => {
        return (
          <div className="LessCashRefunds" key={payment.id}>
            <div className="section">
              <div className="header">
                <LinkText onClick={() => openRefundDetailModal(payment.id)}>
                  Less Cash Refund →
                </LinkText>
                {payment.voided && (
                  <div className="status">
                    <PaymentStatusTag status={PaymentStatusTag.VOIDED} />
                  </div>
                )}
                <div className="date">{formatDate(payment.paymentDate)}</div>
              </div>
              <div className="value">
                <Money amount={payment.amountApplied} />
              </div>
            </div>
          </div>
        );
      })}
      {invoices.map(invoice => {
        return (
          <div className="LessCashRefunds" key={invoice.id}>
            <div className="invoiceSection">
              <div className="header">
                <LinkText onClick={() => openInvoiceDetailModal(invoice.id)}>
                  Less Credit to Invoice {invoice.idString} →
                </LinkText>
                <div className="date">{formatDate(invoice.dateIssued)}</div>
              </div>
              <div className="value">
                <Money amount={invoice.totalIncludingTax} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LessCashRefunds;
